<template>
  <div class="home-wrapper">
    <AccountSettings />
    <v-icon @click="sign_out" class="logout"></v-icon>

    <v-container fluid>
      <v-layout row align-start pb-1>
        <v-flex xs5>
          <ProfilePic
            :image="user_data.big_thumbnail"
            @upload="saveData"
            :accountActive="!user_data.accountNotActivated"
          />
        </v-flex>
        <v-flex @click="bottomSheet = 'view_profile'" xs7 pl-2 class="text-xs-left">
          <h3 class="name-with-settings">
            <span :title="user_data.team_name">{{ user_data.team_name }}</span>
            <v-icon ml-1>mdi-pencil</v-icon>
          </h3>
          <h4 class="header-thin">
            {{ user_data.category ? user_data.category.league : '' }}
          </h4>
          <h4 class="header-thin">{{ user_data.verband }}</h4>
          <h5>
            <flag class="flag" :iso="user_data.nationality" />
            {{ getNationality }}
          </h5>
        </v-flex>
      </v-layout>

      <v-layout mt-4 mb-1 align-start>
        <v-flex xs12 py-2 px-3 class="matches-box">
          <v-layout mb-2>
            <v-flex xs3>
              <h3>Matches</h3>
            </v-flex>
            <v-flex xs9 class="text-xs-right" style="font-size: 12px">
              <div class="mt-1">
                <span
                  class="d-inline-block filter-span"
                  :class="{ 'filter-span-active': selectedMatchType === 'all' }"
                  @click="selectedMatchType = 'all'"
                  >Alle</span
                >
                <span
                  class="d-inline-block filter-span"
                  :class="{ 'filter-span-active': selectedMatchType === 'player' }"
                  @click="selectedMatchType = 'player'"
                  >Spieler</span
                >
                <span
                  class="d-inline-block filter-span"
                  :class="{ 'filter-span-active': selectedMatchType === 'trainer' }"
                  @click="selectedMatchType = 'trainer'"
                  >Trainer</span
                >
                <span
                  class="d-inline-block"
                  :class="{ 'filter-span-active': selectedMatchType === 'teams' }"
                  @click="selectedMatchType = 'teams'"
                  >Scouts</span
                >
              </div>
            </v-flex>
          </v-layout>
          <div
            v-if="filteredUserMatches && filteredUserMatches.length"
            class="scrolling-wrapper-flexbox"
            style="margin-top: 10px"
          >
            <MatchPreview
              @click="openMatchedProfile(match)"
              class="player-preview"
              v-for="match in filteredUserMatches"
              :key="match.chat_id"
              :picture="
                match.player_id === user_data.id ? match.logo : match.profile_pic
              "
              :msg="match.lastMessage"
              :chat-id="match.chat_id"
              :name="match.player_id === user_data.id ? match.team : match.player_name"
              :details="
                match.type === 'teams' ? match.contactByDetails : match.contactDetails
              "
              :showRemoveButton="true"
              :selectedMatch="match"
            ></MatchPreview>
          </div>
          <v-flex my-3 v-else class="text-xs-center">
            <v-icon large color="white">mdi-volleyball</v-icon>
            <h4 style="color: white">Aktuell keine Matches vorhanden.</h4>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout mt-4 align-start>
        <v-flex xs12 py-2 px-3 class="connect-box">
          <v-layout mb-2>
            <v-flex xs11>
              <h3>Connect-Anfragen</h3>
              <small>Diese Anfragen warten noch auf deine Bestätigung.</small>
            </v-flex>
            <v-flex xs1>
              <div class="mt-1" @click="bottomSheet = 'search_settings'">
                <v-icon>filter</v-icon>
              </div>
            </v-flex>
          </v-layout>
          <h5 v-if="playersConnected.length">Spieler</h5>
          <div
            v-if="playersConnected.length"
            class="scrolling-wrapper-flexbox"
            style="margin-top: 10px"
          >
            <template v-for="player in playersConnected">
              <ConnectPreview
                class="player-preview"
                v-if="player"
                :key="player.team_id"
                :picture="player.profile_pic"
                :name="player.name"
                :nationality="player.nationality"
                :detail1="player.position_specific"
                :detail2="
                  player.no_team === true || player.no_team === 'nein'
                    ? player.currentTeam
                    : 'Vereinslos'
                "
                @click="openProfile(player, 'showPlayer')"
              ></ConnectPreview>
            </template>
          </div>
          <h5 v-if="trainersConnected.length">Trainer</h5>
          <div
            v-if="trainersConnected.length"
            class="scrolling-wrapper-flexbox"
            style="margin-top: 10px"
          >
            <template v-for="appliedTrainer in trainersConnected">
              <ConnectPreview
                class="player-preview"
                v-if="appliedTrainer"
                :key="appliedTrainer.team_id"
                :picture="appliedTrainer.profile_pic"
                :name="appliedTrainer.name"
                :nationality="appliedTrainer.nationality"
                :detail1="appliedTrainer.trainer_type"
                :detail2="
                  appliedTrainer.no_team === true || appliedTrainer.no_team === 'nein'
                    ? appliedTrainer.currentTeam
                    : 'Vereinslos'
                "
                @click="openProfile(appliedTrainer, 'showTrainer')"
              ></ConnectPreview>
            </template>
          </div>
          <div class="full-spinner" v-if="loadingConnectQuestions">
            <v-progress-circular indeterminate color="green"></v-progress-circular>
          </div>
          <v-flex
            my-3
            v-else-if="!trainersConnected.length && !playersConnected.length"
            class="text-xs-center"
          >
            <v-icon large>mdi-chat-processing-outline</v-icon>
            <h4 style="color: grey">Aktuell keine offenen Connect-Anfragen.</h4>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>

    <div class="button-box">
      <div class="button-wrapper mt-3">
        <!-- <v-btn color="white" @click="bottomSheet = 'search_settings'" class="menu-button main main-big mb-3">
          <v-icon>filter</v-icon>
        </v-btn>
        <label class="label-big">Spieler- & Trainerattribute</label> -->
      </div>
    </div>

    <!-- edit profile -->
    <v-card
      :class="['bottom-sheet', { active: bottomSheet !== 'hidden' ? true : false }]"
    >
      <v-icon @click="closeMenu" class="closeBtn">keyboard_backspace</v-icon>
      <div class="settings">
        <v-tabs
          class="tabs"
          fixed-tabs
          background-color="white"
          slider-color="light-green accent-4"
        >
          <v-tab href="#Vereinsdaten">Vereinsdaten</v-tab>
          <v-tab href="#Teams">Teams</v-tab>
          <v-tab href="#Gallery">Galerie</v-tab>
          <v-tabs-items v-model="tab" :touchless="true">
            <v-tab-item :value="'Vereinsdaten'">
              <v-card class="overview-profile" flat>
                <!-- <b>{{$store.state.user_data.history[$store.state.user_data.history.length-1].team_name}}</b> -->

                <label>Vereinsname</label>
                <v-text-field
                  color="green"
                  v-model="$store.state.user_data.team_name"
                  solo
                />

                <label>Sportlicher Leiter</label>
                <v-text-field
                  placeholder="Vor- und Nachname"
                  color="green"
                  v-model="$store.state.user_data.sportlicher_leiter"
                  solo
                />
                <label>Cheftrainer/-in</label>
                <v-text-field
                  placeholder="Vor- und Nachname"
                  color="green"
                  v-model="$store.state.user_data.cheftrainer"
                  solo
                />
                <label>Ansässig in Land</label>
                <v-autocomplete
                  color="green"
                  :items="this.$store.state.nationalities"
                  item-text="item_text"
                  item-value="id"
                  v-model="user_data.nationality"
                  solo
                  attach
                ></v-autocomplete>
                <label>Region/Verband</label>
                <v-select
                  color="green"
                  :items="$store.state.verband"
                  v-model="user_data.verband"
                  solo
                  :disabled="!isSubscriptionExpired"
                ></v-select>
                <label v-if="user_data.verband">Aktuelle Liga</label>
                <v-select
                  v-if="user_data.verband"
                  color="green"
                  :items="$store.state.filter_leagues[user_data.verband]"
                  item-text="league"
                  item-value="category"
                  return-object
                  v-model="user_data.category"
                  solo
                  :disabled="!isSubscriptionExpired"
                ></v-select>
                <v-divider></v-divider>

                <h2 class="text-xs-left">Trainerteam</h2>
                <label>Co-Trainer/-in</label>
                <v-text-field
                  placeholder="Vor- und Nachname"
                  color="green"
                  v-model="$store.state.user_data.co_trainer"
                  solo
                />
                <label>Torwarttrainer/in</label>
                <v-text-field
                  placeholder="Vor- und Nachname"
                  color="green"
                  v-model="$store.state.user_data.goalkeeper_trainer"
                  solo
                />
                <label>Fitnesstrainer/in</label>
                <v-text-field
                  placeholder="Vor- und Nachname"
                  color="green"
                  v-model="$store.state.user_data.fitness_trainer"
                  solo
                />
                <label>Athletiktrainer/in</label>
                <v-text-field
                  placeholder="Vor- und Nachname"
                  color="green"
                  v-model="$store.state.user_data.athletic_trainer"
                  solo
                />
                <label>Mentaltrainer/in</label>
                <v-text-field
                  placeholder="Vor- und Nachname"
                  color="green"
                  v-model="$store.state.user_data.mental_trainer"
                  solo
                />

                <label>Teammanager</label>
                <v-text-field
                  placeholder="Vor- und Nachname"
                  color="green"
                  v-model="$store.state.user_data.team_manager"
                  solo
                />
                <label>Physiotherapeut/in</label>
                <v-text-field
                  placeholder="Vor- und Nachname"
                  color="green"
                  v-model="$store.state.user_data.physiotherapeut"
                  solo
                />
                <label>Betreuer/in</label>
                <v-text-field
                  placeholder="Vor- und Nachname"
                  color="green"
                  v-model="$store.state.user_data.betreuer"
                  solo
                />
                <v-divider></v-divider>

                <h2 class="text-xs-left">Links</h2>
                <label for>Link Transfermarkt-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.transfermarkt"
                  hint="Kopiere den Link vom Transfermarkt-Profil."
                  solo
                ></v-text-field>

                <label>Link FuPa-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.fupa"
                  hint="Kopiere den Link vom FuPa-Profil."
                  solo
                ></v-text-field>

                <label>Link Facebook-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.facebook"
                  hint="Kopiere den Link von deinem Facebook-Profil."
                  solo
                ></v-text-field>

                <label>Link Instagram-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.instagram"
                  hint="Kopiere den Link von deinem Instagram-Profil."
                  solo
                ></v-text-field>

                <label>Link Website (optional)</label>
                <v-text-field
                  hint="Kopiere die URL der Website."
                  color="green"
                  v-model="user_data.website"
                  solo
                ></v-text-field>

                <v-list>
                  <v-list-group no-action>
                    <template v-slot:activator>
                      <h2>Mehr Infos</h2>
                    </template>

                    <label>Bio</label>
                    <v-textarea
                      placeholder="Was zeichnet deinen Verein aus?"
                      color="green"
                      v-model="$store.state.user_data.bio"
                      solo
                    ></v-textarea>
                    <label>Vereinsgründung</label>
                    <v-menu
                      ref="founded_menu"
                      v-model="founded_menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      color="green"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          color="green"
                          v-model="formatFoundedDate"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="green"
                        ref="picker"
                        v-model="user_data.founded"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1800-01-01"
                      ></v-date-picker>
                    </v-menu>
                    <label>Vereinsvorsitzende/r</label>
                    <v-text-field
                      placeholder="Vor- und Nachname"
                      color="green"
                      v-model="$store.state.user_data.ceo"
                      solo
                    />
                    <label>Stadionname</label>
                    <v-text-field color="green" v-model="user_data.stadionname" solo />
                    <label>Größte Erfolge bisher</label>
                    <v-textarea
                      placeholder="Aufstiege, Meistertitel, Pokalsiege..."
                      color="green"
                      v-model="$store.state.user_data.biggest_success"
                      solo
                    />
                  </v-list-group>
                </v-list>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="'Teams'">
              <v-card class="overview-profile" flat>
                <v-list>
                  <v-list-group
                    v-for="(item, i) in user_data.history"
                    :key="i"
                    v-model="item.active"
                    no-action
                  >
                    <template v-slot:activator>
                      <div class="history-wrapper list-name">
                        <h2
                          v-text="
                            `Mannschaft: ${item.team ? item.team : 'bitte angeben'}`
                          "
                        ></h2>
                      </div>
                    </template>

                    <div class="history-content">
                      <v-icon
                        @click="deleteEntry(i)"
                        class="delete"
                        color="red"
                      ></v-icon>
                      <div class="history-column">
                        <div class="history-column">
                          <label>Mannschaft</label>
                          <v-select
                            color="green"
                            :items="$store.state.age_classes"
                            v-model="item.team"
                            solo
                            muslitpl
                          ></v-select>
                        </div>
                        <div class="history-column">
                          <label>Region/Verband</label>
                          <v-select
                            color="green"
                            :items="$store.state.verband"
                            v-model="item.verband"
                            solo
                          ></v-select>
                          <label v-if="item.verband">Liga</label>
                          <v-select
                            v-if="item.verband"
                            color="green"
                            :items="$store.state.filter_leagues[item.verband]"
                            item-text="league"
                            item-value="league"
                            return-object
                            v-model="item.category"
                            solo
                          ></v-select>
                          <label>Trainer</label>
                          <v-text-field
                            color="green"
                            v-model="item.trainer"
                          ></v-text-field>
                          <label>Co-Trainer</label>
                          <v-text-field
                            color="green"
                            v-model="item.co_trainer"
                          ></v-text-field>
                        </div>
                      </div>
                    </div>
                  </v-list-group>
                </v-list>
                <v-btn
                  @click="user_data.history.push({ team: null })"
                  class="primary-btn"
                  >Neuer Eintrag</v-btn
                >
              </v-card>
            </v-tab-item>
            <v-tab-item :value="'Gallery'">
              <GalleryTab @save-data="saveImage" />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
    </v-card>

    <!-- view profile -->
    <v-card
      :class="[
        'bottom-sheet',
        {
          active:
            bottomSheet !== 'hidden' && bottomSheet == 'view_profile' ? true : false,
        },
      ]"
    >
      <v-icon @click="bottomSheet = 'hidden'" class="closeBtn"
        >keyboard_backspace</v-icon
      >
      <div class="bottom-sheet-head">
        <h3>
          <flag class="flag" :iso="user_data.nationality" />
          <b>{{ user_data.team_name }}</b>
        </h3>
      </div>
      <div class="profile">
        <TeamData :user-data="user_data" />
        <v-tabs
          class="tabs"
          fixed-tabs
          background-color="white"
          slider-color="light-green accent-4"
        >
          <v-tab href="#Vereinsdaten">Vereinsdaten</v-tab>
          <v-tab href="#Teams">Teams</v-tab>
          <v-tab href="#Gallery">Galerie</v-tab>
          <v-tabs-items v-model="tab_mehr">
            <v-tab-item :value="'Vereinsdaten'">
              <v-card class="overview-profile" flat>
                <v-list>
                  <v-list-group no-action>
                    <template v-slot:activator>
                      <h3>Mehr Infos</h3>
                    </template>

                    <div>
                      <div class="history-content">
                        <div class="flex-row-wrap">
                          <div>
                            <label>Vereinsgründung</label>
                            {{ formatFoundedDate }}
                          </div>
                          <div>
                            <label>Stadionname</label>
                            {{ user_data.stadionname }}
                          </div>
                          <div>
                            <label>Größte Erfolge bisher</label>
                            {{ user_data.biggest_success }}
                          </div>
                          <div>
                            <label>Co-Trainer/-in</label>
                            {{ $store.state.user_data.co_trainer }}
                          </div>
                          <div>
                            <label>Torwarttrainer/in</label>
                            {{ $store.state.user_data.goalkeeper_trainer }}
                          </div>
                          <div>
                            <label>Fitnesstrainer/in</label>
                            {{ $store.state.user_data.fitness_trainer }}
                          </div>
                          <div>
                            <label>Athletiktrainer/in</label>
                            {{ $store.state.user_data.athletic_trainer }}
                          </div>
                          <div>
                            <label>Mentaltrainer/in</label>
                            {{ $store.state.user_data.mental_trainer }}
                          </div>
                          <div>
                            <label>Vereinsvorsitzende/r</label>
                            {{ $store.state.user_data.ceo }}
                          </div>
                          <div>
                            <label>Teammanager</label>
                            {{ $store.state.user_data.team_manager }}
                          </div>
                          <div>
                            <label>Physiotherapeut/in</label>
                            {{ $store.state.user_data.physiotherapeut }}
                          </div>
                          <div>
                            <label>Betreuer/in</label>
                            {{ $store.state.user_data.betreuer }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-list-group>
                </v-list>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="'Teams'">
              <v-card class="overview-teams" flat>
                <v-list v-if="user_data.history && user_data.history.length > 0">
                  <v-list-group
                    v-for="(item, i) in user_data.history"
                    :key="i"
                    v-model="item.active"
                    no-action
                    v-show="item.team"
                  >
                    <template v-slot:activator>
                      <div class="history-wrapper list-name">
                        <h3 v-text="`${item.team ? item.team : 'bitte angeben'}`"></h3>
                      </div>
                    </template>
                    <div class="flex-row-wrap">
                      <div>
                        <label>Mannschaft</label>
                        {{ item.team }}
                      </div>
                      <div v-if="item.category">
                        <label>Aktuelle Liga</label>
                        {{ item.category ? item.category.league : '' }}
                      </div>
                      <div>
                        <label>Trainer</label>
                        {{ item.trainer }}
                      </div>
                      <div>
                        <label>Co-Trainer</label>
                        {{ item.co_trainer }}
                      </div>
                    </div>
                  </v-list-group>
                </v-list>
                <div v-else class="history-content">
                  <h3>Bisher keine Teams angegeben.</h3>
                </div>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="'Gallery'">
              <v-card class="overview-career" flat>
                <div class="overview-profile" flat>
                  <div class="history-content">
                    <GalleryContent
                      v-if="hasPictures"
                      :images="bindedUserData.galleryImages"
                    />
                    <div v-else class="history-content">
                      <h3>Bisher keine Galerie angelegt.</h3>
                    </div>

                    <LinkCard
                      v-if="hasLinks"
                      :links="bindedUserData.videolinks"
                      :title="'Videos'"
                    />
                    <LinkCard
                      v-if="hasArticles"
                      :links="bindedUserData.newslinks"
                      :title="'Zeitungsartikel'"
                    />
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
      <div class="button-box-sticky" style="flex-direction: column">
        <button
          color="white"
          @click="bottomSheet = 'profile_settings'"
          class="menu-button main main-small mb-1"
        >
          <!-- <v-icon>edit</v-icon> -->
          PROFIL BEARBEITEN
        </button>
        <!-- <label class="label-big">Profil bearbeiten</label> -->
      </div>
    </v-card>

    <!-- match settings -->
    <v-card
      :class="[
        'bottom-sheet',
        {
          active:
            bottomSheet !== 'hidden' && bottomSheet === 'search_settings'
              ? true
              : false,
        },
      ]"
    >
      <v-icon @click="closeMenu" class="closeBtn">keyboard_backspace</v-icon>
      <div class="settings">
        <h2>Spieler- & Trainerattribute</h2>
        <p>
          Passe die Matching-Kriterien an, die Spieler und Trainer erfüllen müssen,
          damit sie deinen Verein finden können.
        </p>
        <p>
          <b> Wo besteht aktuell Bedarf? </b>
        </p>
        <v-select
          color="green"
          :items="need"
          v-model="user_data.will_be_found_by"
          solo
        ></v-select>
        <v-list class="list">
          <v-list-group
            v-if="
              user_data.will_be_found_by === 'Spieler' ||
              user_data.will_be_found_by === 'Spieler & Trainer'
            "
          >
            <template v-slot:activator>
              <div class="history-wrapper list-name">
                <h3>Spielerattribute</h3>
              </div>
            </template>
            <div>
              <label>Geschlecht</label>
              <v-select
                color="green"
                :items="$store.state.sex"
                multiple
                v-model="user_data.playerprofile_sex"
                solo
              ></v-select>
              <label>
                Alter
                <span v-if="user_data.playerAgeRange"
                  >(von {{ user_data.playerAgeRange[0] }} bis
                  {{ user_data.playerAgeRange[1] }})</span
                >
              </label>
              <v-range-slider
                solo
                class="age-slider"
                color="green"
                v-model="user_data.playerAgeRange"
                :min="14"
                :max="40"
              ></v-range-slider>
              <label>Positionen</label>
              <v-select
                color="green"
                :items="$store.state.positions"
                v-model="user_data.playerprofile_position"
                solo
                multiple
              ></v-select>
            </div>
          </v-list-group>
          <v-list-group
            v-if="
              user_data.will_be_found_by === 'Trainer' ||
              user_data.will_be_found_by === 'Spieler & Trainer'
            "
          >
            <template v-slot:activator>
              <div class="history-wrapper list-name">
                <h3>Trainerattribute</h3>
              </div>
            </template>
            <div>
              <label>Geschlecht</label>
              <v-select
                color="green"
                :items="$store.state.sex"
                multiple
                v-model="user_data.trainerprofile_sex"
                solo
              ></v-select>
              <label>
                Alter
                <span v-if="user_data.trainerAgeRange"
                  >(von {{ user_data.trainerAgeRange[0] }} bis
                  {{ user_data.trainerAgeRange[1] }})</span
                >
              </label>
              <v-range-slider
                solo
                class="age-slider"
                color="green"
                v-model="user_data.trainerAgeRange"
                :min="14"
                :max="80"
              ></v-range-slider>
              <label>Trainertyp</label>
              <v-select
                color="green"
                multiple
                :items="$store.state.trainer_types"
                v-model="user_data.trainerprofile_type"
                solo
              ></v-select>
            </div>
          </v-list-group>
        </v-list>
      </div>
    </v-card>

    <v-dialog v-model="accountNeedVerification" max-width="290">
      <v-card class="text-left">
        <v-card-title class="headline">Verifizierung Vereinsaccount</v-card-title>

        <v-card-text
          >Damit auch ihr den begehrten <b>blauen C4T-Ring</b> für euer Profilbild
          erhaltet, und somit in den Matches von Spielern oder Trainern vorrangig
          angezeigt werdet, müsst ihr euren Account nur noch verifizieren.</v-card-text
        >

        <v-card-actions style="justify-content: center">
          <v-btn color="blue white--text" text @click="verifyAccount"
            >Jetzt verifizieren</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MatchSheetPlayer
      v-if="showPlayer && selectedProfile.id"
      :selectedProfile="selectedProfile"
      @close="showPlayer = false"
      :show="showPlayer"
      :isApplication="true"
    ></MatchSheetPlayer>

    <MatchSheetTrainer
      v-if="showTrainer && selectedProfile.id"
      :selectedProfile="selectedProfile"
      @close="showTrainer = false"
      :show="showTrainer"
      :isApplication="true"
    ></MatchSheetTrainer>

    <ScoutSheet
      v-if="showScout && selectedProfile.id"
      :selectedProfile="selectedProfile"
      @close="showScout = false"
      :show="showScout"
    ></ScoutSheet>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { db } from '@/db';
import LinkCard from '@/components/settings/LinkCard';
import ProfilePic from '@/components/home/ProfilePic';
import GalleryContent from '@/components/settings/GalleryContent';
import AccountSettings from '@/components/settings/AccountSettings';
import MatchPreview from '../../components/home/MatchPreview';
import ConnectPreview from '../../components/home/ConnectPreview';
import TeamData from '../../components/profile/TeamData';
import MatchSheetPlayer from '@/components/match/PlayerSheet';
import MatchSheetTrainer from '@/components/match/TrainerSheet';
import ScoutSheet from '@/components/match/ScoutSheet';
import GalleryTab from '../../components/settings/edit/GalleryTab';
import match from '../../mixins/match';
import common from '../../mixins/common';

export default {
  name: 'home-team',

  components: {
    LinkCard,
    ProfilePic,
    GalleryContent,
    AccountSettings,
    MatchPreview,
    ConnectPreview,
    TeamData,
    MatchSheetPlayer,
    MatchSheetTrainer,
    ScoutSheet,
    GalleryTab,
  },

  mixins: [match, common],

  watch: {
    galleryImages: (oldImages, newImages) => {
      console.log('CHECK');
      console.log(oldImages, newImages);
    },

    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },

    userAppliedPlayersWithoutMatch() {
      console.log('watch players');
      this.getAppliedPlayersAndTrainersWithNoMatches();
    },

    userAppliedTrainersWithoutMatch() {
      console.log('watch trainers');
      this.getAppliedPlayersAndTrainersWithNoMatches();
    },
  },

  data: () => ({
    initialData: {},
    founded_menu: false,
    dialog: false,
    bottomSheet: 'hidden',
    tab: null,
    tab_mehr: null,
    imageKey: 0,
    profile_settings: false,
    search_settings: false,
    view_profile: false,
    email: '',
    password: '',
    picture: '',
    uploading: false,
    need: ['Spieler', 'Trainer', 'Spieler & Trainer', 'Kein Bedarf'],
    items: ['Profi', 'Amateur', 'Halbprofi'],
    showTrainer: false,
    showPlayer: false,
    showScout: false,
    loadingConnectQuestions: false,
  }),

  computed: {
    ...mapState([
      'user_data',
      'userMatches',
      'trainersConnected',
      'playersConnected',
      'bindedUserData',
    ]),
    ...mapGetters([
      'userAppliedPlayersWithoutMatch',
      'userAppliedTrainersWithoutMatch',
    ]),

    formatFoundedDate() {
      if (!this.user_data.founded) return null;

      const [year, month, day] = this.user_data.founded.split('-');
      return `${day}.${month}.${year}`;
    },
    sortedHistory() {
      let sorted = [];
      if (this.$store.state.user_data.history) {
        sorted = this.$store.state.user_data.history.sort((a, b) =>
          a.season < b.season ? 1 : b.season < a.season ? -1 : 0,
        );
      }
      return sorted;
    },

    getNationality() {
      if (this.user_data.nationality) {
        const found = this.$store.state.nationalities.find(
          (element) => element.id === this.user_data.nationality,
        );
        return found.item_text;
      }
      return '';
    },
  },

  methods: {
    openProfile(data, type) {
      this.selectedProfile = data;
      this[type] = true;
    },

    async openMatchedProfile(matchChat) {
      console.log(matchChat);
      let collection;
      let type;
      let docId;

      this.selectedProfile = {};

      if (matchChat.contactByDetails && matchChat.contactByDetails.type === 'scout') {
        this.$store.state.loading = true;
        collection = 'scouts';
        type = 'showScout';
        docId = matchChat.team_id;
      } else if (matchChat.contactDetails) {
        this.$store.state.loading = true;
        collection = matchChat.contactDetails.type === 'trainer' ? 'trainers' : 'users';
        type =
          matchChat.contactDetails.type === 'trainer' ? 'showTrainer' : 'showPlayer';
        docId = matchChat.player_id;
      }

      const contactedBy = await db
        .collection(collection)
        .doc(docId)
        .get({ source: 'server' })
        .then((snapshot) => snapshot.data());

      this.selectedProfile = contactedBy;
      this[type] = true;

      this.$store.state.loading = false;
    },

    async getAppliedPlayersAndTrainersWithNoMatches() {
      this.loadingConnectQuestions = true;
      if (
        this.userAppliedTrainersWithoutMatch &&
        this.userAppliedTrainersWithoutMatch.length > 0
      ) {
        const getTrainers = this.userAppliedTrainersWithoutMatch.map(
          async (element) => {
            const trainer = await db
              .collection('trainers')
              .doc(element)
              .get({ source: 'server' })
              .then((snapshot) => snapshot.data());

            return trainer;
          },
        );

        const trainers = await Promise.all(getTrainers);
        this.$store.commit('updateTrainersConnected', trainers);
      } else {
        this.$store.commit('updateTrainersConnected', []);
      }

      if (
        this.userAppliedPlayersWithoutMatch &&
        this.userAppliedPlayersWithoutMatch.length > 0
      ) {
        const getPlayers = this.userAppliedPlayersWithoutMatch.map(async (element) => {
          const player = await db
            .collection('users')
            .doc(element)
            .get({ source: 'server' })
            .then((snapshot) => snapshot.data());
          return player;
        });
        const players = await Promise.all(getPlayers);
        this.$store.commit('updatePlayersConnected', players);
      } else {
        this.$store.commit('updatePlayersConnected', []);
      }
      this.loadingConnectQuestions = false;
    },

    closeMenu() {
      if (this.initialData === JSON.stringify(this.user_data)) {
      } else {
        this.saveData();
        this.initialData = JSON.stringify(this.user_data);
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Daten gespeichert',
        });
      }
      this.bottomSheet = 'hidden';
    },
    deleteEntry(i) {
      const oldHistory = this.$store.state.user_data.history;
      const remove = oldHistory[i];
      const filteredItems = oldHistory.filter((item) => item !== remove);
      this.$store.state.user_data.history = filteredItems;
    },
    deleteSearchEntry(i) {
      const oldSearch = this.$store.state.user_data.search;
      const remove = oldSearch[i];
      const filteredItems = oldSearch.filter((item) => item !== remove);
      this.$store.state.user_data.search = filteredItems;
    },
    newSearchProfile() {
      const { search } = this.user_data;
      const newSearch = { name: '', position: '', sex: '' };
      const newSearchProfiles = [...search, newSearch];
      this.user_data.search = newSearchProfiles;
    },
    sign_out() {
      this.$store.state.logout_dialog = true;
    },
    saveImage() {
      db.collection('teams')
        .doc(this.$store.state.user_data.id)
        .update({ ...this.$store.state.user_data })
        .then(() => {
          this.$forceUpdate();
        });
    },
    saveData() {
      this.clearLinks();

      db.collection('teams')
        .doc(this.$store.state.user_data.id)
        .update({ ...this.$store.state.user_data })
        .then(() => {
          this.$forceUpdate();
        });
    },
  },

  beforeMount() {
    this.initialData = JSON.stringify(this.$store.state.user_data);
    this.getAppliedPlayersAndTrainersWithNoMatches();
  },

  created() {
    document.body.classList.add('main-background');
    this.accountNeedVerification = this.user_data.accountNotActivated;
  },
};
</script>
